import { render } from "./color-picker-panel.vue?vue&type=template&id=69559542&scoped=true"
import script from "./color-picker-panel.vue?vue&type=script&lang=js"
export * from "./color-picker-panel.vue?vue&type=script&lang=js"

import "./color-picker-panel.vue?vue&type=style&index=0&id=69559542&rel=stylesheet%2Fscss&lang=scss&scoped=true"

import exportComponent from "D:\\work\\npm\\vue3-color-picker-gradient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69559542"]])

export default __exports__